<div class="side-navigation">
    <div class="side-navigation-wrapper">
        <a
            class="main-node {{ gtmPrefix }}-side-navigation-node selenium-side-navigation-node"
            [attr.data-gtmlabel]="navigationNode.title"
            [routerLink]="navigationNode.getRouterLink()"
        >
            <h4>{{ navigationNode.title }}</h4>
        </a>
        <h6 class="selenium-in-this-collection-label">In this collection:</h6>
        <app-side-navigation-nodes
            [childrenNodes]="navigationNode.children"
            [activeNode]="activeNode"
            [styles]="styles"
            [gtmPrefix]="gtmPrefix"
            [firstLevel]="true"
        >
        </app-side-navigation-nodes>
    </div>
</div>
